"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateRef = void 0;
var react_1 = require("react");
function useStateRef(initial) {
    var ref = react_1.useRef(initial);
    var setRef = react_1.useCallback(function (v) {
        ref.current = v;
    }, []);
    return [ref, setRef];
}
exports.useStateRef = useStateRef;
//# sourceMappingURL=useStateRef.js.map